import { apiService } from '@/shared/services/apiServices';
import { QMS_CATEGORY_ERROR_MESSAGES } from '../errors/errorMessages';
import type { QmsTag } from '../types/qmsCategoryTypes';
import qmsCategoryEndpoints from './qmsCategoryEndpoints';

export interface ListQmsTagsParams {
  page?: number;
  limit?: number;
  search?: string;
}

export interface ListQmsTagsResult {
  success: boolean;
  tags: QmsTag[];
  totalCount: number;
  hasNextPage: boolean;
  error?: string;
}

interface ListQmsTagsApiResponse {
  data: QmsTag[];
  totalCount: number;
  page: number;
  limit: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export const listQmsTags = async (
  params: ListQmsTagsParams = {}
): Promise<ListQmsTagsResult> => {
  try {
    const result = await apiService.getAPI(qmsCategoryEndpoints.TAGS, {
      params: {
        page: params.page ?? 1,
        limit: params.limit ?? 10,
        ...(params.search ? { search: params.search } : {}),
      },
    });

    if (!result.error) {
      const body = result.data as ListQmsTagsApiResponse;
      return {
        success: true,
        tags: body.data ?? [],
        totalCount: body.totalCount ?? 0,
        hasNextPage: body.hasNextPage ?? false,
      };
    }

    if (result.isNetworkError) {
      return {
        success: false,
        tags: [],
        totalCount: 0,
        hasNextPage: false,
        error: QMS_CATEGORY_ERROR_MESSAGES.NETWORK_ERROR,
      };
    }

    return {
      success: false,
      tags: [],
      totalCount: 0,
      hasNextPage: false,
      error: QMS_CATEGORY_ERROR_MESSAGES.DEFAULT_ERROR,
    };
  } catch {
    return {
      success: false,
      tags: [],
      totalCount: 0,
      hasNextPage: false,
      error: QMS_CATEGORY_ERROR_MESSAGES.UNEXPECTED_ERROR,
    };
  }
};
